import { useDisclosure } from '@chakra-ui/react';
import { useEffect } from 'react';
import {
  CustomerComplianceDocument,
  customersApi,
} from '@texas/api/endpoints/customersApi';
import { useApiResource } from '@texas/api/hooks/useApiResource';
import { useValueDisclosure } from '@texas/hooks/useValueDisclosure';
import { customerComplianceDocumentEvents } from './events';

export function useCustomerComplianceDocuments(customerId: number) {
  const { data, loading, error, refetch } = useApiResource(
    customersApi.getComplianceDocuments,
  );
  const assignDisclosure = useDisclosure();
  const removeDisclosure = useValueDisclosure<CustomerComplianceDocument>();

  useEffect(() => {
    refetch(customerId);
  }, [customerId, refetch]);

  useEffect(() => {
    return customerComplianceDocumentEvents.changed.subscribe((changedId) => {
      if (changedId === customerId) refetch(customerId);
    });
  }, [customerId, refetch]);

  return {
    documents: data ?? [],
    loading: loading || (data === null && error === null),
    error,
    assignDisclosure,
    removeDisclosure,
  };
}
